// import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
// import {clusterApiUrl } from '@solana/web3.js';
import { useWallet, WalletProvider } from '@solana/wallet-adapter-react';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { Connection } from '@solana/web3.js';
import { useMemo } from 'react';
import '@solana/wallet-adapter-react-ui/styles.css';

export const useSolanaWallet = () => {
    const endpoint = 'https://bliss-5q7u5z-fast-mainnet.helius-rpc.com/'; // Use your own RPC network
    const wallets = useMemo(() => [new PhantomWalletAdapter()], []);

    const { publicKey, sendTransaction, connected } = useWallet();
    const connection = new Connection(endpoint);

    return {
        publicKey,
        sendTransaction,
        connected,
        connection,
        wallets,
        endpoint,
    };
};

export const WalletConnectionProvider = ({ children }) => {
    const wallets = useMemo(() => [new PhantomWalletAdapter()], []);
    return (
        <WalletProvider wallets={wallets} autoConnect>
            {children}
        </WalletProvider>
    );
};